import GenericError from './GenericError'

// eslint-disable-next-line import/no-unused-modules
export default GenericError
